import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Carousel from './components/Carousel';
import Topics from './components/Topics';
import Cards from './components/Cards';
import About from './components/About';
import App from './components/App';
import Faq from './components/Faq';
import Comments from './components/Comments';
import Media from './components/Media';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Index from './components/Index';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Carousel />
        <Topics />
        <Cards />
        <About />
        <App />
        <Faq />
        <Comments />
        <Media />
        <Updates />
        <Ranking />
        <Index />
        <Contact />
      </main>
      <Footer />
    </>
  );
}